import { ReactNode } from 'react';
import styled from 'styled-components';
import { ExtraInfoTableWrapper, ExtraInfoTableContent } from '../../ExtraInfoTable/ExtraInfoTable';
import { buildGeneralInfoTableData } from '../buildGeneralInfoTableData';
import { type PrescriptionLink } from '../../PrescriptionLinkList/PrescriptionLinkList';
import Hairline from 'design-system/src/components/Hairline/Hairline';

const StyledExtraInfoTableWrapper = styled(ExtraInfoTableWrapper)`
  gap: 1rem;
  margin: 0;
`;

export type ModalGeneralInfoTableProps = {
  // First and last name
  patientName: string | null;
  // First and last name
  prescriberName: string | null;
  // Unformatted datestring
  dob: string | null;
  // Unformatted datestring
  prescribedOn: string | null;
  drugName: string | null;
  prescriptionId: string | null;
  // Whether to show the drug name as a link to the Rx page. Defaults to true.
  linkDrugToRxPage?: boolean;
  relatedPrescriptions?: PrescriptionLink[];
  // Anything else you want tacked on to the bottom of the table
  extraData?: Array<{ label: string; value: string | null | ReactNode }>;
};

/**
 * Modal-specific version of GeneralInfoTable with no vertical margin and 1rem gap
 */
export const ModalGeneralInfoTable = ({
  patientName,
  prescriberName,
  dob,
  prescribedOn,
  drugName,
  prescriptionId,
  linkDrugToRxPage = true,
  relatedPrescriptions = [],
  extraData = [],
}: ModalGeneralInfoTableProps) => {
  const data = buildGeneralInfoTableData({
    patientName,
    prescriberName,
    dob,
    prescribedOn,
    drugName,
    prescriptionId,
    linkDrugToRxPage,
    relatedPrescriptions,
    extraData,
  });

  return (
    <div>
      <StyledExtraInfoTableWrapper $marginTop="0" $tableMarginBottom="0">
        <ExtraInfoTableContent data={data} />
      </StyledExtraInfoTableWrapper>
      <Hairline $marginTop="1rem" $marginBottom="0" />
    </div>
  );
};
